import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../data/content";
import { Ornament } from "./Ornament";
import { Instagram, Mail, Phone } from "lucide-react";

const FOOTER_LINKS = [
  { path: "/", label: "Home" },
  { path: "/services", label: "Services" },
  { path: "/experiences", label: "Experiences" },
  { path: "/concept-store", label: "Concept Store" },
  { path: "/recent-projects", label: "Recent Projects" },
  { path: "/about", label: "About" },
  { path: "/book-a-call", label: "Book a Call" },
  { path: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer
      className="relative bg-[var(--lu-black)] border-t border-[var(--lu-gold)]/40 pt-14 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="font-serif italic text-ivory-80 text-[20px]">Let's create something</p>
        <p className="font-serif text-[46px] sm:text-[64px] text-[var(--lu-gold)] leading-none">Excellent</p>
        <Ornament className="mt-8" />

        {/* Site map links */}
        <nav
          aria-label="Footer navigation"
          className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3"
        >
          {FOOTER_LINKS.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className="font-micro text-[10px] tracking-[0.3em] uppercase text-ivory-70 hover:text-[var(--lu-gold)] transition-colors"
              data-testid={`footer-link-${l.path === "/" ? "home" : l.path.slice(1)}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* Contact block */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[13px] text-ivory-70">
          <a
            href={`tel:+30${BRAND.phone.replace(/\s/g, "")}`}
            className="flex items-center gap-2 hover:text-[var(--lu-gold)]"
          >
            <Phone size={14} /> +30 {BRAND.phone}
          </a>
          <a
            href={`mailto:${BRAND.email}`}
            className="flex items-center gap-2 hover:text-[var(--lu-gold)]"
          >
            <Mail size={14} /> {BRAND.email}
          </a>
          <a
            href={`https://instagram.com/${BRAND.instagram}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-[var(--lu-gold)]"
          >
            <Instagram size={14} /> @{BRAND.instagram}
          </a>
        </div>

        {/* NAP for LocalBusiness SEO */}
        <address className="mt-8 not-italic text-[12px] text-ivory-50">Lumière Entertainment · Athens, Attica, Greece · Bespoke luxury event
          entertainment in Greece, Italy, France, Spain, UAE &amp; destination
          worldwide.</address>

        <p className="mt-8 font-micro text-[10px] text-ivory-70">
          {BRAND.name} &nbsp;·&nbsp; {BRAND.tagline}
        </p>
        <p className="mt-2 text-[12px] text-ivory-40">
          © {new Date().getFullYear()} Lumière Entertainment. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
